import React from "react";
import { Card } from "react-bootstrap";
import { gettext } from "../shared/utils/legacy";
import dacom from "../images/dacom.svg";

export interface ReportOverviewCardProps {
  title: string;
  img?: string;
  href: string;
  content: string;
  fit?: "cover" | "contain";
}

const ReportsOverviewCard = ({
  title,
  content,
  href,
  img = dacom,
  fit = "cover",
}: ReportOverviewCardProps) => {
  return (
    <div className={"col-12 col-md-4 p-3"}>
      <Card style={{ borderRadius: "8px", margin: "auto", maxWidth: "22rem", height: "100%" }}>
        <a href={href}>
          <Card.Img variant="top" src={img} style={{ maxHeight: "8rem", objectFit: fit }} />
        </a>
        <Card.Body style={{ padding: "1.75rem 1.5rem 1.5rem" }}>
          <Card.Title style={{ hyphens: "auto" }}>
            <h4 className={"mb-2"}>{title}</h4>
          </Card.Title>
          <Card.Text>{content}</Card.Text>
        </Card.Body>
        <Card.Footer style={{ padding: "1.5rem" }}>
          <a href={href}>{gettext("Go to report")}</a>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default ReportsOverviewCard;
